import { apiClientV1 } from './apiClient';

export default {
  getGeneralHostVideoTypes: () => apiClientV1.get('/video/host-video-types'),
  getHostVideoTypes: (params) => apiClientV1.get('/video/property/host-video-types', { params }),
  getHostVideoTypeDefaultSegments: (hostVideoTypeId) => apiClientV1.get(`/video/host-video-type/${hostVideoTypeId}/default-segments`)
};
